<template>
  <hr class="border-lgmx_gray-100" />
</template>

<script>
export default {};
</script>

<style></style>
